import { initStorageInstance } from './index'
import {
  IMAGE_GUID_URL_MAP_KEY,
  USER_AUTHORIZATION_STORAGE_KEY,
  USER_LOCATIONINFO_STORAGE_KEY,
  USER_ENTRY_URL_STORAGE_KEY,
  CRM_AREA_INFO_STORAGE_KEY,
} from './constant'

export const ImageGuidUrlMapStorage = initStorageInstance(IMAGE_GUID_URL_MAP_KEY, {
  type: 'sessionStorage',
})

export const UserAuthorizationStorage = initStorageInstance(USER_AUTHORIZATION_STORAGE_KEY, {
  type: 'localStorage',
  verifyMobile: true,
})

// 存储需要一直使用的经纬度，需要注意甄别是否可以用缓存的经纬度
export const UserLocationInfoStorage = initStorageInstance(USER_LOCATIONINFO_STORAGE_KEY, {
  type: 'sessionStorage',
  verifyMobile: true,
})

// 存储进入的地址
export const userEntryUrlStorage = initStorageInstance(USER_ENTRY_URL_STORAGE_KEY, {
  type: 'sessionStorage',
})

// CRM地区数据缓存
export const CrmAreaInfoStorage = initStorageInstance(CRM_AREA_INFO_STORAGE_KEY, {
  type: 'sessionStorage',
})
